module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#video-play",
      toString: function () {
        return this.url;
      }
    }